import React from "react";
import {
  Container,
  Dots,
  IndicatorText,
  Next,
  NumberBtn,
  PageIndicator,
  PaginationWrapper,
  Prev,
} from "./Pagination.Elements";

const Pagination = ({ page, setPage, totalPages }) => {
  let total = totalPages;
  let totalArray;

  if (total < 5) {
    totalArray = Array(total);

    for (let i = 0; i < total; i++) {
      totalArray[i] = i + 1;
    }
  }

  return (
    <Container>
      {totalPages < 5 ? (
        <PaginationWrapper>
          {totalArray.map((e) => (
            <NumberBtn onClick={() => setPage(e)}>{e}</NumberBtn>
          ))}
        </PaginationWrapper>
      ) : (
        <PaginationWrapper>
          {/* previous button */}
          {page > 2 && <Prev onClick={() => setPage(page - 1)}>Prev</Prev>}
          {page > 2 && <Dots>...</Dots>}
          {/* Last page is visible then show this :Last related button*/}
          {page === total && (
            <NumberBtn onClick={() => setPage(page - 2)}>{page - 2}</NumberBtn>
          )}

          {/* current page is 2 and more then show this for previous :Left sibling*/}
          {page > 1 && (
            <NumberBtn onClick={() => setPage(page - 1)}>{page - 1}</NumberBtn>
          )}

          {/*current page*/}
          <NumberBtn onClick={() => setPage(page)}>{page} </NumberBtn>

          {/* current page 9 and greater then omit this :Right sibling */}
          {page < total && (
            <NumberBtn onClick={() => setPage(page + 1)}>{page + 1}</NumberBtn>
          )}

          {/* current page 1 then show this :First related button*/}
          {page === 1 && (
            <NumberBtn onClick={() => setPage(page + 2)}>{page + 2}</NumberBtn>
          )}

          {page < total - 1 && <Dots>...</Dots>}

          {/* next button */}
          {page < total - 1 && (
            <Next onClick={() => setPage(page + 1)}>Next</Next>
          )}
          {/* <span>current page :{page}</span>
          <span>total pages: {totalPages}</span> */}
        </PaginationWrapper>
      )}
      <PageIndicator>
        <IndicatorText>
          Page {page} of {total}
        </IndicatorText>
      </PageIndicator>
    </Container>
  );
};

export default Pagination;
